// The sales area's ONE mutation-failure note — the waste area's task-#105
// extraction, re-owned here because that copy is hard-wired to `waste.*` keys
// and the `.waste-error-note` class (each area owns its own; a cross-area
// import would be module 09's refusals styled by module 05's stylesheet).
//
// A WRITE's refusal carries three facts, in this order: the area's own
// sentence naming the VERB that failed, the server's own problem `title` when
// the refusal produced one, and the `request_id` — the same request-id line
// the §4 read card keeps. The server's title renders AS the server's —
// labelled and untranslated (problem titles are wire English, D-022 keeps the
// translatable machinery in `errors[].message_key`) — so a Russian screen
// shows a Russian sentence naming the verb and then the server's own words,
// never a paraphrase of them. It renders only when the SERVER actually said
// it: `RequestError.message` falls back to the hook's English label when the
// body was not a problem, and printing that fallback would dress a network
// cut up as a server sentence.
//
// Callers keep PER-VERB error state and reset siblings on every press (the
// task-#105 idiom the remnant registry proved): at most one note on the glass,
// and it is always the CURRENT claim.
//
// ONE CODE IS SAID IN THE READER'S LANGUAGE (D-318). 503 `RESOURCE_BUSY` is the
// answer of the five doors that price before they write (the quote create,
// the revise, the duplicate, the order requote and the direct order) when the
// customer was edited during each of three passes. Nothing was written and
// the same press can be made again a moment later, so the note says so in the
// reader's language (`sales.common.busyRetry`) in place of the server's
// English title. Every other code keeps the server's title as before.

import { useTranslation } from "react-i18next";
import { RequestError, requestIdOf } from "../../../lib/request";

export function MutationFailureNote({
  text,
  error,
  "data-testid": testId,
}: {
  text: string;
  error: unknown;
  "data-testid"?: string;
}) {
  const { t } = useTranslation();
  const requestId = requestIdOf(error);
  const busy = error instanceof RequestError && error.code === "RESOURCE_BUSY";
  const serverTitle = error instanceof RequestError && !busy ? error.problem?.title : undefined;
  return (
    <p className="sales-error-note" role="alert" data-testid={testId}>
      {text}
      {busy ? <> {t("sales.common.busyRetry")}</> : null}
      {serverTitle !== undefined && serverTitle.length > 0 ? (
        <> {t("sales.common.serverSaid", { title: serverTitle })}</>
      ) : null}
      {requestId !== undefined ? (
        <>
          {" "}
          {t("sales.common.requestId")}: <code>{requestId}</code>
        </>
      ) : null}
    </p>
  );
}
